/**
 * Capitalize filter
 */

angular.module("common").filter("capitalize", function () {
  return function (input, scope) {
    return typeof input == "string" ? input.substring(0, 1).toUpperCase() + input.substring(1) : input;
  };
});
